import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import { post, get } from "../../../helpers/api_helper";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_GetMachiningOutwardDetailByID,
  POST_GetProcessListForOutward,
  POST_GetVendorsDDLList,
  POST_GetVoucherSeriesDDLList,
  POST_InsertMachiningOutward,
  POST_UpdateMachiningOutward,
} from "../../../helpers/url_helper";
import moment from "moment";

const AddMachineOutward = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const [outwardNoOptions, setOutwardNoOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);

  // const [selectedCheckbox, setSelectedCheckbox] = useState(1);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    VendorIDEncrypt: Yup.string().trim().required("Vendor is required field"),
    MachiningOutwardNo: Yup.string()
      .trim()
      .required("Outward No is required field"),
    // Remarks: Yup.string().trim().required("Remarks is required field"),
    OutwardDate: Yup.string().trim().required("Outward Date is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      MachiningOutwardIDEncrypt: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      VendorIDEncrypt: "",
      OutwardStatus: 1,
      MachiningOutwardNo: "",
      OutwardDate: new Date(),
      ExpectedDate: "",
      Remarks: "",
      ListOfVendorProcessDetail: [],
      // ListOfVendorProcessDetailFinal: [],
      // ListOfVendorProcessDetailSelected: [],
      ProcessSearch: "",
      TCNoSearch: "",
      ProcessNoteSearch: "",
      QtySearch: "",
      LengthSearch: "",
      ThicknessSearch: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      OutwardStatus,
      MachiningOutwardIDEncrypt,
      ListOfVendorProcessDetail,
      // ListOfVendorProcessDetailFinal,
      // ListOfVendorProcessDetailSelected,
      ProcessSearch,
      TCNoSearch,
      ProcessNoteSearch,
      QtySearch,
      LengthSearch,
      ThicknessSearch,
      OutwardDate,
      ExpectedDate,
      MachiningOutwardNo,
    },
  } = formik;

  useEffect(() => {
    if (!OutwardDate) {
      formik.setFieldValue("OutwardDate", "");
    } else {
      if (ExpectedDate && ExpectedDate < OutwardDate) {
        formik.setFieldValue("ExpectedDate", "");
      }
    }
  }, [OutwardDate]);

  const handleValidSubmit = (values) => {
    if (
      ListOfVendorProcessDetail?.filter((x) => x.IsSelected == true)?.length ==
      0
    ) {
      formik.setFieldError(
        "ListOfVendorProcessDetail",
        "Process Detail is required"
      );
      formik.setFieldTouched("ListOfVendorProcessDetail", true);

      return;
    }

    setIsLoading(true);

    let ProcessDetailList = [];

    ProcessDetailList = values?.ListOfVendorProcessDetail?.map((item) => ({
      MachiningOutwardDetailIDEncrypt: item?.MachiningOutwardDetailIDEncrypt,
      MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
      InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
      InwardMachiningDetailIDEncrypt: item?.InwardMachiningDetailIDEncrypt,
      Invoicing: item?.IsSelectedInvoicing,
      IsSelected: item?.IsSelected,
    }));

    let payload = {
      // ...values,
      MachiningOutwardIDEncrypt: values?.MachiningOutwardIDEncrypt,
      VendorIDEncrypt: values?.VendorIDEncrypt,
      MachiningOutwardNo: values?.MachiningOutwardNo,
      OutwardDate: values?.OutwardDate
        ? moment(values?.OutwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ExpectedDate: values?.ExpectedDate
        ? moment(values?.ExpectedDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      OutwardRemarks: values?.Remarks,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      MachiningOutwardDetails: ProcessDetailList,
      OutwardStatus: values?.OutwardStatus,
    };

    post(
      PrimaryIdParam
        ? POST_UpdateMachiningOutward
        : POST_InsertMachiningOutward,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          // swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            // navigate("/machining-outward-list");
            navigate(-1);
          }, 1000);
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    // console.log("Save", ListOfVendorProcessDetail);
  };

  useEffect(() => {
    getVendorDDL();
    getOutwardNoDDL();
    //getVendorProcessDetails();

    if (PrimaryIdParam) {
      GetMachiningOutwardDetailByID(MachiningOutwardIDEncrypt);
    } else {
      getVendorProcessDetails();
    }
  }, []);

  const GetMachiningOutwardDetailByID = async (id) => {
    setIsLoading(true);
    await post(POST_GetMachiningOutwardDetailByID, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      MachiningOutwardIDEncrypt: id,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          //Set Details

          formik.setValues({
            MachiningOutwardIDEncrypt: response?.MachiningOutwardIDEncrypt,
            VendorIDEncrypt: response?.VendorIDEncrypt,
            OutwardStatus: response?.OutwardStatus,
            MachiningOutwardNo: response?.MachiningOutwardNo,
            OutwardDate: response?.OutwardDate,
            ExpectedDate: response?.ExpectedDate,
            Remarks: response?.OutwardRemarks,

            ListOfVendorProcessDetail: response?.MachiningOutwardDetails?.map(
              (item) => ({
                MachiningConfigurationIDEncrypt:
                  item?.MachiningConfigurationIDEncrypt,
                InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
                InwardMachiningDetailIDEncrypt:
                  item?.InwardMachiningDetailIDEncrypt,
                ProcessName: item?.ProcessName,
                TCNo: item?.TCNo,
                Note: item?.MachiningNote,
                Qty: item?.Qty,
                Length: item?.Length,
                Thickness: item?.Thickness,
                VendorRate: item?.VendorRate,
                InvoiceRate: item?.InvoiceRate,
                IsDelete: item?.IsDelete,
                IsSelectedInvoicing: item?.Invoicing,
                IsSelected: item?.IsSelected,
                MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
                MachiningOutwardDetailIDEncrypt:
                  item?.MachiningOutwardDetailIDEncrypt,
                OutwardStatus: item?.OutwardStatus,
                display: true,
                IsHold: item?.IsHold,
                HoldReason: item?.HoldReason,
                IsExist: item?.IsExist,
              })
            ),

            // ListOfVendorProcessDetailFinal:
            //   response?.MachiningOutwardDetails?.map((item) => ({
            //     MachiningConfigurationIDEncrypt:
            //       item?.MachiningConfigurationIDEncrypt,
            //     InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
            //     InwardMachiningDetailIDEncrypt:
            //       item?.InwardMachiningDetailIDEncrypt,
            //     ProcessName: item?.ProcessName,
            //     TCNo: item?.TCNo,
            //     Note: item?.MachiningNote,
            //     Qty: item?.Qty,
            //     Length: item?.Length,
            //     Thickness: item?.Thickness,
            //     VendorRate: item?.VendorRate,
            //     InvoiceRate: item?.InvoiceRate,
            //     IsDelete: item?.IsDelete,
            //     IsSelectedInvoicing: item?.Invoicing,
            //     IsSelected: item?.IsSelected,
            //     MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
            //     MachiningOutwardDetailIDEncrypt:
            //       item?.MachiningOutwardDetailIDEncrypt,
            //     OutwardStatus: item?.OutwardStatus,
            //     display: true,
            //   })),

            // ListOfVendorProcessDetailSelected:
            //   response?.MachiningOutwardDetails?.map((item) => ({
            //     MachiningConfigurationIDEncrypt:
            //       item?.MachiningConfigurationIDEncrypt,
            //     InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
            //     InwardMachiningDetailIDEncrypt:
            //       item?.InwardMachiningDetailIDEncrypt,
            //     ProcessName: item?.ProcessName,
            //     TCNo: item?.TCNo,
            //     Note: item?.MachiningNote,
            //     Qty: item?.Qty,
            //     Length: item?.Length,
            //     Thickness: item?.Thickness,
            //     VendorRate: item?.VendorRate,
            //     InvoiceRate: item?.InvoiceRate,
            //     IsDelete: item?.IsDelete,
            //     IsSelectedInvoicing: item?.Invoicing,
            //     IsSelected: item?.IsSelected,
            //     MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
            //     MachiningOutwardDetailIDEncrypt:
            //       item?.MachiningOutwardDetailIDEncrypt,
            //     OutwardStatus: item?.OutwardStatus,
            //     display: true,
            //   })),
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getVendorDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVendorsDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setVendorOptions(
            response?.VendorsList?.map((item) => ({
              label: item.VendorName,
              value: item.VendorIDEncrypt,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getOutwardNoDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 17, // 1 = OutwardNo
      TranDate: OutwardDate
        ? moment(OutwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setOutwardNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item.VoucherSeries,
              value: item.VoucherSeriesIDEncrypt,
            }))
          );
          if (MachiningOutwardNo) {
            if (
              response?.VoucherSeriesList?.filter(
                (x) => x.VoucherSeriesIDEncrypt == MachiningOutwardNo
              )?.length == 0
            ) {
              formik.setFieldValue("MachiningOutwardNo", "");
            }
          } else {
            /*select the value when there is only one option while insert only*/
            if (response?.VoucherSeriesList?.length == 1 && !PrimaryIdParam) {
              formik.setFieldValue(
                "MachiningOutwardNo",
                response?.VoucherSeriesList[0].VoucherSeriesIDEncrypt
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getVendorProcessDetails = async () => {
    //setIsLoading(true);

    setIsLoading(true);
    await post(POST_GetProcessListForOutward, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfVendorProcessDetail",
            response?.ProcessList?.map((item) => ({
              MachiningConfigurationIDEncrypt:
                item?.MachiningConfigurationIDEncrypt,
              InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
              InwardMachiningDetailIDEncrypt:
                item?.InwardMachiningDetailIDEncrypt,
              ProcessName: item?.ProcessName,
              TCNo: item?.TCNo,
              Note: item?.MachiningNote,
              Qty: item?.Qty,
              Length: item?.Length,
              Thickness: item?.Thickness,
              VendorRate: item?.VendorRate,
              InvoiceRate: item?.InvoiceRate,
              IsDelete: item?.IsDelete,
              IsSelectedInvoicing: item?.Invoicing,
              IsSelected: item?.IsSelected,
              MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
              MachiningOutwardDetailIDEncrypt:
                item?.MachiningOutwardDetailIDEncrypt,
              OutwardStatus: item?.OutwardStatus,
              display: true,
              IsHold: item?.IsHold,
              HoldReason: item?.HoldReason,
              IsExist: item?.IsExist,
            }))
          );

          // formik.setFieldValue(
          //   "ListOfVendorProcessDetailFinal",
          //   response?.ProcessList?.map((item) => ({
          //     MachiningConfigurationIDEncrypt:
          //       item?.MachiningConfigurationIDEncrypt,
          //     InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
          //     InwardMachiningDetailIDEncrypt:
          //       item?.InwardMachiningDetailIDEncrypt,
          //     ProcessName: item?.ProcessName,
          //     TCNo: item?.TCNo,
          //     Note: item?.MachiningNote,
          //     Qty: item?.Qty,
          //     Length: item?.Length,
          //     Thickness: item?.Thickness,
          //     VendorRate: item?.VendorRate,
          //     InvoiceRate: item?.InvoiceRate,
          //     IsDelete: item?.IsDelete,
          //     IsSelectedInvoicing: item?.Invoicing,
          //     IsSelected: item?.IsSelected,
          //     MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
          //     MachiningOutwardDetailIDEncrypt:
          //       item?.MachiningOutwardDetailIDEncrypt,
          //     OutwardStatus: item?.OutwardStatus,
          //     display: true,
          //   }))
          // );

          // formik.setFieldValue(
          //   "ListOfVendorProcessDetailSelected",
          //   response?.ProcessList?.map((item) => ({
          //     MachiningConfigurationIDEncrypt:
          //       item?.MachiningConfigurationIDEncrypt,
          //     InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
          //     InwardMachiningDetailIDEncrypt:
          //       item?.InwardMachiningDetailIDEncrypt,
          //     ProcessName: item?.ProcessName,
          //     TCNo: item?.TCNo,
          //     Note: item?.MachiningNote,
          //     Qty: item?.Qty,
          //     Length: item?.Length,
          //     Thickness: item?.Thickness,
          //     VendorRate: item?.VendorRate,
          //     InvoiceRate: item?.InvoiceRate,
          //     IsDelete: item?.IsDelete,
          //     IsSelectedInvoicing: item?.Invoicing,
          //     IsSelected: item?.IsSelected,
          //     MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
          //     MachiningOutwardDetailIDEncrypt:
          //       item?.MachiningOutwardDetailIDEncrypt,
          //     OutwardStatus: item?.OutwardStatus,
          //     display: true,
          //   }))
          // );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeSearchProcessName = async (
    ProcessSearchText,
    TCNoSearchText,
    ProcessNoteSearchText,
    QtySearchText,
    LengthSearchText,
    ThicknessSearchText
  ) => {
    // // alert(TCNoSearchText);

    // let newList = ListOfVendorProcessDetailSelected?.filter(
    //   (x, ix) => x.IsSelected == true
    // );

    // let newListSeleAllFalse = ListOfVendorProcessDetailFinal?.filter(
    //   (x, ix) => x.IsSelected == false
    // );

    // // console.log("newList", newList);

    // // let newListSeleAllFalse = ListOfVendorProcessDetailFinal?.map(
    // //   (item, idx) => {
    // //     return {
    // //       ...item,
    // //       IsSelected: false,
    // //     };
    // //   }
    // // );

    // // let newListSeleAll = newListSeleAllFalse?.map((item, idx) => {
    // //   newList?.map((itemSel, idxSel) => {
    // //     if (itemSel.IsSelected == true) {
    // //       if (itemSel.ProcessIDEncrypt == item.ProcessIDEncrypt) {
    // //         item.IsSelected = true;
    // //       }
    // //     } else {
    // //       item.IsSelected = false;
    // //     }
    // //   });

    // //   return { ...item };
    // // });

    // let newFinalList = newListSeleAllFalse.filter(
    //   (x) =>
    //     x?.ProcessName?.toLowerCase().includes(
    //       ProcessSearchText?.toLowerCase()
    //     ) &&
    //     x?.TCNo?.toLowerCase().includes(TCNoSearchText?.toLowerCase()) &&
    //     x?.Note?.toLowerCase().includes(ProcessNoteSearchText?.toLowerCase()) &&
    //     x?.Qty?.toLowerCase().includes(QtySearchText?.toLowerCase()) &&
    //     x?.Length?.toLowerCase().includes(LengthSearchText?.toLowerCase()) &&
    //     x?.Thickness?.toLowerCase().includes(ThicknessSearchText?.toLowerCase())
    // );

    // formik.setFieldValue("ListOfVendorProcessDetail", [
    //   ...newList,
    //   ...newFinalList?.filter((x, ix) => x.IsSelected == false),
    // ]);

    let newList = ListOfVendorProcessDetail?.filter(
      (x, ix) => x.IsSelected == true
    );

    let newFinalList = ListOfVendorProcessDetail?.filter(
      (x, ix) => x.IsSelected == false
    )?.map((x) => {
      if (
        x?.ProcessName?.toLowerCase().includes(
          ProcessSearchText?.toLowerCase()
        ) &&
        x?.TCNo?.toLowerCase().includes(TCNoSearchText?.toLowerCase()) &&
        x?.Note?.toLowerCase().includes(ProcessNoteSearchText?.toLowerCase()) &&
        x?.Qty?.toLowerCase().includes(QtySearchText?.toLowerCase()) &&
        x?.Length?.toLowerCase().includes(LengthSearchText?.toLowerCase()) &&
        x?.Thickness?.toLowerCase().includes(ThicknessSearchText?.toLowerCase())
      ) {
        return { ...x, display: true };
      } else {
        return { ...x, display: false };
      }
    });

    formik.setFieldValue("ListOfVendorProcessDetail", [
      ...newList,
      ...newFinalList,
    ]);
  };

  // const checkProcessDetailSelected = async (e, indx) => {
  //   // alert(ProcessSearchText);
  //   //setSelectedCheckbox(itemId);

  //   if (e?.target?.checked == true) {
  //     //alert(e?.target?.checked);

  //     formik.setFieldValue(
  //       `ListOfVendorProcessDetailSelected`,
  //       ListOfVendorProcessDetail?.map((item, indxTest) => {
  //         if (indxTest == indx) {
  //           return {
  //             ...item,
  //             IsSelected: true,
  //           };
  //         } else {
  //           return {
  //             ...item,
  //           };
  //         }
  //       })
  //     );
  //   } else {
  //     formik.setFieldValue(
  //       `ListOfVendorProcessDetailSelected`,
  //       ListOfVendorProcessDetail?.map((item, indxTest) => {
  //         if (indxTest == indx) {
  //           if (item.IsSelected == true) {
  //             return {
  //               ...item,
  //               IsSelected: false,
  //             };
  //           }
  //         } else {
  //           return {
  //             ...item,
  //           };
  //         }
  //       })
  //     );
  //   }

  //   //...newfinalList?.filter((x, ix) => x.IsSelected == false),
  //   //  console.log("SelectedList", ListOfVendorProcessDetailSelected);
  // };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Machining Outward
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Vendor"
                      name="VendorIDEncrypt"
                      placeholder={"Select Vendor"}
                      options={vendorOptions}
                      component={CustomSelect}
                      isClearable={false}
                      // onChange={handleChangeVendor}
                      required
                      autoFocus
                    />
                  </Col>
                  <Col lg={3}>
                    {MachiningOutwardIDEncrypt ? (
                      <Field
                        label="Outward No"
                        name="MachiningOutwardNo"
                        component={CustomInput}
                        disabled={true}
                      />
                    ) : (
                      <Field
                        label="Outward No"
                        name="MachiningOutwardNo"
                        placeholder={"Select Outward No"}
                        options={outwardNoOptions}
                        component={CustomSelect}
                        required
                      />
                    )}

                    {/* <Field
                      label="Outward No"
                      name="MachiningOutwardNo"
                      placeholder={"Select Outward No"}
                      options={outwardNoOptions}
                      component={CustomSelect}
                      required
                    /> */}
                  </Col>
                  <Col lg={3}>
                    {MachiningOutwardIDEncrypt ? (
                      <Field
                        label="Outward Date"
                        name="OutwardDate"
                        component={CustomInput}
                        disabled={true}
                      />
                    ) : (
                      <Field
                        label="Outward Date"
                        name="OutwardDate"
                        placeholder={"Select Outward Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                        }}
                        required
                      />
                    )}
                  </Col>

                  <Col lg={3}>
                    <Field
                      label="Expected Date of Return"
                      name="ExpectedDate"
                      placeholder={"Select Expected Date of Return"}
                      component={CustomFlatpickr}
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                        minDate: OutwardDate,
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <Field
                      label="Remarks"
                      name="Remarks"
                      rows={2}
                      placeholder={"Enter Remarks"}
                      component={CustomTextArea}
                      maxLength={500}
                    />
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="VendorProcessDetail-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="VendorProcessDetail-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="2%" className="p-1"></th>
                              <th width="21%" className="p-1">
                                Process
                              </th>
                              <th width="15%" className="p-1">
                                TC No
                              </th>
                              <th width="16%" className="p-1">
                                Note
                              </th>
                              <th width="11%" className="p-1">
                                Qty
                              </th>
                              <th width="12%" className="p-1">
                                Length
                              </th>
                              <th width="15%" className="p-1">
                                Thickness
                              </th>
                              <th
                                width="8%"
                                className="p-1"
                                style={{ textAlign: "center" }}
                              >
                                Invoicing
                              </th>
                            </tr>
                            <tr>
                              <th className="p-1 pt-0"></th>
                              <th width="20%" className="p-1 pt-0">
                                <Field
                                  name="ProcessSearch"
                                  placeholder={"Search Process"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "ProcessSearch",
                                      e?.target?.value ?? ""
                                    );

                                    handleChangeSearchProcessName(
                                      e?.target?.value ?? "",
                                      TCNoSearch ? TCNoSearch : "",
                                      ProcessNoteSearch
                                        ? ProcessNoteSearch
                                        : "",
                                      QtySearch ? QtySearch : "",
                                      LengthSearch ? LengthSearch : "",
                                      ThicknessSearch ? ThicknessSearch : ""
                                    );
                                  }}
                                />
                              </th>
                              <th width="15%" className="p-1 pt-0">
                                <Field
                                  name="TCNoSearch"
                                  placeholder={"Search TC No"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "TCNoSearch",
                                      e?.target?.value ?? ""
                                    );

                                    handleChangeSearchProcessName(
                                      ProcessSearch ? ProcessSearch : "",
                                      e?.target?.value ?? "",
                                      ProcessNoteSearch
                                        ? ProcessNoteSearch
                                        : "",
                                      QtySearch ? QtySearch : "",
                                      LengthSearch ? LengthSearch : "",
                                      ThicknessSearch ? ThicknessSearch : ""
                                    );
                                  }}
                                />
                              </th>
                              <th width="15%" className="p-1 pt-0">
                                <Field
                                  name="ProcessNoteSearch"
                                  placeholder={"Search Note"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "ProcessNoteSearch",
                                      e?.target?.value ?? ""
                                    );
                                    handleChangeSearchProcessName(
                                      ProcessSearch ? ProcessSearch : "",
                                      TCNoSearch ? TCNoSearch : "",
                                      e?.target?.value ?? "",
                                      QtySearch ? QtySearch : "",
                                      LengthSearch ? LengthSearch : "",
                                      ThicknessSearch ? ThicknessSearch : ""
                                    );
                                  }}
                                />
                              </th>
                              <th width="15%" className="p-1 pt-0">
                                <Field
                                  name="QtySearch"
                                  placeholder={"Search Qty"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "QtySearch",
                                      e?.target?.value ?? ""
                                    );
                                    handleChangeSearchProcessName(
                                      ProcessSearch ? ProcessSearch : "",
                                      TCNoSearch ? TCNoSearch : "",
                                      ProcessNoteSearch
                                        ? ProcessNoteSearch
                                        : "",
                                      e?.target?.value ?? "",
                                      LengthSearch ? LengthSearch : "",
                                      ThicknessSearch ? ThicknessSearch : ""
                                    );
                                  }}
                                />
                              </th>
                              <th width="15%" className="p-1 pt-0">
                                <Field
                                  name="LengthSearch"
                                  placeholder={"Search Length"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "LengthSearch",
                                      e?.target?.value ?? ""
                                    );
                                    handleChangeSearchProcessName(
                                      ProcessSearch ? ProcessSearch : "",
                                      TCNoSearch ? TCNoSearch : "",
                                      ProcessNoteSearch
                                        ? ProcessNoteSearch
                                        : "",
                                      QtySearch ? QtySearch : "",
                                      e?.target?.value ?? "",
                                      ThicknessSearch ? ThicknessSearch : ""
                                    );
                                  }}
                                />
                              </th>
                              <th width="15%" className="p-1 pt-0">
                                <Field
                                  name="ThicknessSearch"
                                  placeholder={"Search Thickness"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "ThicknessSearch",
                                      e?.target?.value ?? ""
                                    );
                                    handleChangeSearchProcessName(
                                      ProcessSearch ? ProcessSearch : "",
                                      TCNoSearch ? TCNoSearch : "",
                                      ProcessNoteSearch
                                        ? ProcessNoteSearch
                                        : "",
                                      QtySearch ? QtySearch : "",
                                      LengthSearch ? LengthSearch : "",
                                      e?.target?.value ?? ""
                                    );
                                  }}
                                />
                              </th>
                              <th className="p-1 pt-0 text-center">
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        Only the selected processes will be
                                        considered for invoicing.
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <i
                                      className="fa fa-info-circle ms-2"
                                      style={{
                                        cursor: "pointer",
                                        color: "#9698ab",
                                      }}
                                    ></i>
                                  </span>
                                </OverlayTrigger>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfVendorProcessDetail?.filter(
                              (x) => x.display == true
                            )?.length > 0 ? (
                              ListOfVendorProcessDetail?.map((item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display: item.display == true ? "" : "none",
                                  }}
                                >
                                  <td
                                    style={{
                                      minWidth: "50px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkProcess${indx}`}
                                      name={`chkProcess${indx}`}
                                      checked={item?.IsSelected}
                                      disabled={
                                        item?.IsHold
                                          ? true
                                          : item?.OutwardStatus == 2
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        if (item?.IsHold == false) {
                                          if (item?.IsExist) {
                                            formik.setFieldValue(
                                              `ListOfVendorProcessDetail[${indx}].IsSelected`,
                                              false
                                            );
                                            warningMessage(
                                              "Some of the selected processes are associated with other pending Machining Inward records."
                                            );
                                          } else {
                                            formik.setFieldValue(
                                              `ListOfVendorProcessDetail[${indx}].IsSelected`,
                                              e?.target?.checked
                                            );
                                          }
                                          // checkProcessDetailSelected(e, indx);
                                        }
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "150px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.ProcessName}
                                  </td>
                                  <td style={{ minWidth: "100px" }}>
                                    {item.TCNo}{" "}
                                    {item?.IsHold == true && (
                                      <>
                                        <b>[Hold]</b>
                                        <OverlayTrigger
                                          trigger={["hover", "focus"]}
                                          key={indx}
                                          responsive={true}
                                          overlay={
                                            <Tooltip className="toltip-popover">
                                              <strong className="p-1">
                                                {item?.HoldReason}
                                              </strong>
                                            </Tooltip>
                                          }
                                        >
                                          <span>
                                            <i
                                              className="fa fa-info-circle ms-2"
                                              style={{
                                                cursor: "pointer",
                                                color: "#9698ab",
                                              }}
                                            ></i>
                                          </span>
                                        </OverlayTrigger>
                                      </>
                                    )}
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "200px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.Note}
                                  </td>
                                  <td style={{ minWidth: "100px" }}>
                                    {item.Qty}
                                  </td>
                                  <td style={{ minWidth: "100px" }}>
                                    {item.Length}
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "200px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.Thickness}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      minWidth: "50px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkInvoicing${indx}`}
                                      name={`chkInvoicing${indx}`}
                                      checked={item.IsSelectedInvoicing}
                                      disabled={
                                        item?.OutwardStatus == 2 ? true : false
                                      }
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListOfVendorProcessDetail[${indx}].IsSelectedInvoicing`,
                                          e?.target?.checked
                                        );
                                      }}
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  <div>{"No options"}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <ErrorMessage
                      name={"ListOfVendorProcessDetail"}
                      component="div"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    />
                  </Col>
                </Row>
                <div className="stickyBottomButtons">
                  <hr className="mt-1 mb-2"></hr>
                  <button
                    type="submit"
                    // className="btn btn-primary"
                    className="btn btn-primary btn-sm me-2"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AddMachineOutward;
